import { useEffect, useState } from "react";
import { getConsent, setConsent } from "@/lib/consent";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (getConsent() === null) setShow(true);
  }, []);

  if (!show) return null;

  const decide = (v: "granted" | "denied") => {
    setConsent(v);
    setShow(false);
    if (v === "granted") {
      // Re-fire page view so analytics captures the landing page
      window.dispatchEvent(new Event("kakaiys:consent-granted"));
    }
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 bg-foreground text-background p-6 shadow-2xl"
    >
      <div className="eyebrow mb-2 text-background/70">Privacy</div>
      <p className="text-sm leading-relaxed">
        We use cookies to measure traffic and improve your experience. You can accept or
        decline non-essential cookies. See our{" "}
        <a href="/privacy" className="underline underline-offset-4">
          privacy policy
        </a>
        .
      </p>
      <div className="mt-5 flex gap-3">
        <button
          onClick={() => decide("granted")}
          className="flex-1 bg-gold text-ink py-3 text-[10px] uppercase tracking-[0.28em]"
        >
          Accept
        </button>
        <button
          onClick={() => decide("denied")}
          className="flex-1 border border-background/30 py-3 text-[10px] uppercase tracking-[0.28em]"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
